import {i18n} from "@/plugins/i18n";

export const paymentStatus = {
    PAID_BY_ADMIN: 1,
    UNPAID: 2,
    PAID: 3,
}

export const paymentStatusStr = {
    PAID_BY_ADMIN: i18n.t('online_contract.payment_status.paid_by_admin'),
    UNPAID: i18n.t('online_contract.payment_status.unpaid'),
    PAID: i18n.t('online_contract.payment_status.paid'),

    get(status) {
        let status_str = null;

        Object.keys(paymentStatus).forEach(item => {
            if (paymentStatus[item] === status) {
                status_str = paymentStatusStr[item];
            }
        });

        return status_str;
    }
}